import { useEffect, useState } from 'react';
import SimpleBar from '~/components/third-party/SimpleBar';
import useAuth from '~/hooks/useAuth';

import NavUser from './NavUser';
import Navigation from './Navigation';
import WhatsNew from './WhatsNew';

const DrawerContent = () => {
  const [navigationKey, setNavigationKey] = useState(0);

  const { userRole } = useAuth();

  useEffect(() => {
    setNavigationKey((prev) => prev + 1);
  }, [userRole]);

  if (userRole) {
    return (
      <>
        <SimpleBar
          sx={{
            '& .simplebar-content': {
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          <Navigation key={navigationKey} />
        </SimpleBar>
        <WhatsNew />
        <NavUser />
      </>
    );
  } else {
    return <div />;
  }
};

export default DrawerContent;
